var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m17.2 15.8 4.5 4.5c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3s-.5-.1-.7-.3l-4.5-4.5c-1.5 1.1-3.3 1.8-5.3 1.8C5.8 19 2 15.2 2 10.5S5.8 2 10.5 2 19 5.8 19 10.5c0 2-.7 3.9-1.8 5.3M10.5 4C6.9 4 4 6.9 4 10.5S6.9 17 10.5 17c1.8 0 3.4-.7 4.6-1.9s1.9-2.8 1.9-4.6C17 6.9 14.1 4 10.5 4",
  clipRule: "evenodd"
})));
export default SvgSearch;